import React from 'react';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Checkbox } from 'antd';

import { CommonTnc } from '../CommonTnc';

export const AgreementCheckbox = (props: { onChange: (e: CheckboxChangeEvent) => void }) => {
  return (
    <Checkbox onChange={props.onChange}>
      <CommonTnc />
    </Checkbox>
  );
};
